/**
 * Shared map helpers — pure functions that turn domain data into neutral
 * map points, so RN (react-native-maps) and wunderguide-web (MapLibre GL)
 * derive pins from one implementation and can't drift. Each client maps a
 * `MapPoint` onto its own native marker type.
 */
import type { CatalogItemSummary } from '@wg/types';

export interface MapPoint {
  id: string;
  lat: number;
  lng: number;
  title?: string;
}

/**
 * Convert catalog search results to map points, dropping any item without
 * usable coordinates. Safe on partial data — returns [] for an empty/garbage
 * list rather than throwing.
 */
export function catalogItemsToMapPoints(
  items: CatalogItemSummary[] | null | undefined,
): MapPoint[] {
  if (!Array.isArray(items)) return [];
  const points: MapPoint[] = [];
  for (const item of items) {
    const lat = item?.location?.lat;
    const lng = item?.location?.lng;
    if (typeof lat === 'number' && typeof lng === 'number') {
      points.push({ id: item.id, lat, lng, title: item.title });
    }
  }
  return points;
}
